export enum ReferenceNumberType {
  InvoiceNumber,
  PoNumber
}
